import { render, staticRenderFns } from "./TextField.vue?vue&type=template&id=f5484cc6&scoped=true&"
import script from "./TextField.vue?vue&type=script&lang=js&"
export * from "./TextField.vue?vue&type=script&lang=js&"
import style0 from "./TextField.vue?vue&type=style&index=0&id=f5484cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5484cc6",
  null
  
)

export default component.exports